import { render, staticRenderFns } from "./c_is_show.vue?vue&type=template&id=680ab08a&scoped=true"
import script from "./c_is_show.vue?vue&type=script&lang=js"
export * from "./c_is_show.vue?vue&type=script&lang=js"
import style0 from "./c_is_show.vue?vue&type=style&index=0&id=680ab08a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680ab08a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680ab08a')) {
      api.createRecord('680ab08a', component.options)
    } else {
      api.reload('680ab08a', component.options)
    }
    module.hot.accept("./c_is_show.vue?vue&type=template&id=680ab08a&scoped=true", function () {
      api.rerender('680ab08a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_is_show.vue"
export default component.exports